import { TextInput, Typography } from "@strapi/design-system";
import { useTranslation } from "react-i18next";
import UploadFile from "../uploadFile";
import { useState, useEffect } from "react";

const ThesisResult = ({ data, setData }) => {
  const { t } = useTranslation();
  const [fileList, setFileList] = useState([]);

  useEffect(() => {
    if (!data?.attachment) {
      setFileList([]);
      return;
    }

    const items = Array.isArray(data.attachment)
      ? data.attachment
      : [data.attachment];

    let uploadedImages = [];
    if (localStorage.getItem("uploaded_images")) {
      uploadedImages = JSON.parse(localStorage.getItem("uploaded_images"));
    }

    const tmp = [];
    items.forEach((element) => {
      if (element?.id) {
        tmp.push({
          uid: element.id,
          name: element.name || "New File",
          url: element.url,
          status: "done",
        });
      } else if (uploadedImages.length > 0) {
        const img = uploadedImages.find((x) => x.id === element);
        if (img) {
          tmp.push({
            uid: img.id,
            name: img.name,
            url: img.url,
            status: "done",
          });
        } else {
          tmp.push({
            uid: element,
            name: "New File",
            url: "",
            status: "done",
          });
        }
      } else {
        tmp.push({
          uid: element,
          name: "New File",
          url: "",
          status: "done",
        });
      }
    });

    setFileList(tmp);
  }, [data?.attachment]);

  const handleSetName = (result) => {
    setData({ ...data, result });
  };

  const handleChangeAttachment = (resFile) => {
    const current = data?.attachment;
    let attachments = [];

    if (Array.isArray(current)) {
      attachments = [...current];
    } else if (current) {
      attachments = [current];
    }

    attachments.push(resFile?.id ?? resFile);
    setData({
      ...data,
      attachment: attachments,
    });
  };

  const handleRemoveAttachment = (id) => {
    const current = data?.attachment;
    if (!current) return;

    const attachments = (Array.isArray(current) ? current : [current]).filter(
      (x) => (x?.id ?? x) !== id
    );

    setData({
      ...data,
      attachment: attachments.length ? attachments : null,
    });
  };

  return (
    <div>
      <TextInput
        label={t("str_thesis_result")}
        name="result"
        onChange={(e) => handleSetName(e.target.value)}
        value={data?.result || ""}
      />
      <br />

      <Typography variant="pi" fontWeight="bold">
        {t("str_thesis_result_proof")}
      </Typography>
      <br />
      <span className="subnotes">{t("str_only_pdf")}</span>
      <br />
      <UploadFile
        fileMimeType={["application/pdf"]}
        fileTypeAllowNames="pdf"
        handleUploadSuccess={handleChangeAttachment}
        fileList={fileList}
        handleRemoveFile={handleRemoveAttachment}
        accept="application/pdf"
      />
    </div>
  );
};

export default ThesisResult;
